import React from 'react';
import { Textarea, Button, PaperClip, Select } from 'components';
import { ServiceService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { CloseIcon } from 'assets/icons';
import { PlanService } from 'services';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalView extends React.Component<Props> {

	state = {
		form: {
			comments: ''
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	changeStatus = (status: number) => {
		Globals.confirm(`¿Desea ${ status == Constants.PLAN_PAYMENT_STATUS.ACCEPTED ? 'aceptar' : 'rechazar' } el pago?`,async () => {
			await PlanService.admin.changeStatus({
				status,
				plan_payment_id: this.props.item?.id,
				comments: this.state.form.comments
			});
			this.props.onClose();
			Globals.showSuccess(`Se ha ${ status == Constants.PLAN_PAYMENT_STATUS.ACCEPTED ? 'aceptado' : 'rechazado' } correctamente el pago`);
		});
	}

	render() {
		return (
			<div id="modal-payment-change-status">
				<div className="container-title">
					<p className="title">¿Que desea hacer con el pago?</p>
					<button className="btn btn-close" onClick={ () => this.props.onClose() }>
						<img src={ CloseIcon } />
					</button>
				</div>
				<Textarea
					rows={ 3 }
					color="white"
					value={ this.state.form.comments }
					name="comments" 
					label="Comentarios (Opcional)"
					onChange={ this.change } />
				<div className="row row-buttons">
					<div className="col-md-6 text-center">
						<Button type="button" onClick={ () => this.changeStatus(Constants.PLAN_PAYMENT_STATUS.REJECTED) }>
							Rechazar
						</Button>
					</div>
					<div className="col-md-6 text-center">
						<Button type="button" className="accept" onClick={ () => this.changeStatus(Constants.PLAN_PAYMENT_STATUS.ACCEPTED) }>
							Aceptar
						</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default ModalView;